"use client";

import React from "react";
import { X, Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * GastronomyWebsite — Section 2: Problem-Lösung-Split
 * Drop-in für: src/pages/GastronomyWebsite/sections/WhyChoosePpcWithZionova.tsx
 *
 * Zweispaltiger Split: links Problem (rote X), rechts Lösung (grüne Checks).
 */

const problems = ["Kein Google-Eintrag = unsichtbar für neue Gäste", "Veraltete Facebook-Seite wirkt unprofessionell", "Speisekarte als PDF? Funktioniert nicht auf dem Handy"];
const solutions = ['Automatische SEO für „Restaurant + Ihre Stadt"', "Digitale Speisekarte — immer aktuell, auf jedem Gerät", "Google Maps, Öffnungszeiten, Kontaktformular integriert"];
export default function WhyChoosePpcWithZionova() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-5xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* LEFT: Problem */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6 leading-tight">
              Das Problem: Ihre Gäste suchen online — und finden Sie nicht
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              93 % aller Restaurantbesuche beginnen mit einer Google-Suche. Ohne
              professionelle Website verlieren Sie täglich potenzielle Gäste an
              die Konkurrenz — die bereits online sichtbar ist.
            </p>
            <ul className="space-y-4">
              {problems.map((p, i) => <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-red-100 text-red-500 shrink-0">
                    <X className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-foreground/90">{p}</span>
                </li>)}
            </ul>
          </div>

          {/* RIGHT: Solution */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-primary mb-6 leading-tight">
              Die Lösung: PAGEMAKER24
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              In unter einer Stunde haben Sie eine professionelle
              Restaurant-Website — mit allem, was Gäste erwarten.
            </p>
            <ul className="space-y-4">
              {solutions.map((s, i) => <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-green-100 text-green-600 shrink-0">
                    <Check className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-foreground/90">{s}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}